import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CourseSwitcher from './CourseSwitcher';
import { ArrowBackOutlined } from '../icons';
import './DashboardTopbar.css';

// Header padrão (logo + concurso ativo) reaproveitado em todas as telas
// pós-login. Por padrão o concurso não pode ser trocado por aqui — troca
// de curso só é permitida onde allowCourseChange={true} for passado
// explicitamente (hoje, só MyMocks.js).
function DashboardTopbar({ allowCourseChange = false, hideCourseSwitcher = false, label, left, right, className = '' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/simulados';

  return (
    <div className={`dashboard-topbar ${className}`.trim()}>
      <div className="dashboard-topbar-left">
        {!isHome && (
          <button
            type="button"
            className="dashboard-back-button"
            aria-label="Voltar"
            onClick={() => navigate(-1)}
          >
            <ArrowBackOutlined fontSize="small" />
          </button>
        )}
        <button
          type="button"
          className="dashboard-logo-button"
          onClick={() => navigate('/simulados')}
        >
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Preparate" className="dashboard-logo-mark" />
          <span className="dashboard-logo-text">Preparate</span>
        </button>
        <span className="dashboard-topbar-divider" />
        {!hideCourseSwitcher && <CourseSwitcher inline disabled={!allowCourseChange} />}
        {label && <span className="dashboard-topbar-label">{label}</span>}
        {left}
      </div>
      {right && <div className="dashboard-topbar-right">{right}</div>}
    </div>
  );
}

export default DashboardTopbar;
